import { NetworkService } from '../../services/NetworkService';

export default {
  created () {
    this.__healthPollingInterval = setInterval(() => this.$store.dispatch('checkServiceHealth'), 60 * 1000);
    new NetworkService().init({
      notify: networkAvailable => this.$store.dispatch('checkServiceHealth'),
      onlineMessage: 'on',
      offlineMessage: 'off',
    });
  },
  destroyed () {
    if (this.__healthPollingInterval) clearInterval(this.__healthPollingInterval);
  },
};
